import { createIcon } from '@chakra-ui/react';

export const Close = createIcon({
  displayName: 'Close',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M5.15417 5.15417C4.83194 5.4764 4.83194 5.99937 5.15417 6.3216L10.8326 12L5.15417 17.6784C4.83194 18.0006 4.83194 18.5236 5.15417 18.8458C5.4764 19.1681 5.99937 19.1681 6.3216 18.8458L12 13.1674L17.6784 18.8458C18.0006 19.1681 18.5236 19.1681 18.8458 18.8458C19.1681 18.5236 19.1681 18.0006 18.8458 17.6784L13.1674 12L18.8458 6.3216C19.1681 5.99937 19.1681 5.4764 18.8458 5.15417C18.5236 4.83194 18.0006 4.83194 17.6784 5.15417L12 10.8326L6.3216 5.15417C5.99937 4.83194 5.4764 4.83194 5.15417 5.15417Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.175"
    />
  ),
});
